import { render, staticRenderFns } from "./ModelReport.vue?vue&type=template&id=8645572c&"
import script from "./ModelReport.vue?vue&type=script&lang=js&"
export * from "./ModelReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports